import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledCardDescription = styled.div`
  display: block;
  display: -webkit-box;
  height: 55px;
  max-height: 55px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;
  position: relative;
  padding-bottom: 5px;

  p {
    margin-top: 0;
    padding-top: 0;
  }

  .fadeout {
    position: absolute;
    bottom: 0em;
    left: 0;
    width: 100%;
    height: 29px;
    background: -webkit-linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    background-image: -moz-linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    background-image: -o-linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    background-image: linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    background-image: -ms-linear-gradient(
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }

  span {
    text-transform: initial !important;
    font-size: 14px !important;
  }
`;

const CardDesciption = (props) => {
  return (
    <StyledCardDescription>
      {props.children}
      <div className="fadeout" />
    </StyledCardDescription>
  );
};

CardDesciption.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

CardDesciption.defaultProps = {
  children: null,
};

export default CardDesciption;
